//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect, useCallback, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";

//custom pages
import "assets/css/custom.css";
import auth from "apis/auth/auth";
import LoginParent from "components/AuthPages/LoginParent";
import Grid from "@material-ui/core/Grid";
import { resetPasswordStyles } from "./styles";
import Loader from "components/Loader/Loader";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
// material-ui icons
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import DoneIcon from "@material-ui/icons/Done";
import CloseIcon from "@material-ui/icons/Close";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";



const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#fff",
    },
    "& .MuiInputBase-input": {
      color: "#fff",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#fff!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#fff!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#fff",
      },
      "&:hover fieldset": {
        borderColor: "#fff",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#fff",
      },
    },
  },
})(TextField);

const toastCss = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
};

export default function ResetPassword() {
  const history = useHistory();
  const location = useLocation();
  const { resetPassword } = auth();
  const { state, dispatch } = useContext(Context);

  const classes = resetPasswordStyles();

  const [states, setstates] = useState({});
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState({});

  const [passwordNeed, setPasswordNeed] = useState(false);
  const [confirmPasswordNeed, setConfirmPasswordNeed] = useState(false);




  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    if (location.state && location.state.emailResponse) {
      document.addEventListener("contextmenu", (event) => {
        event.preventDefault();
      });
      return;
    }
    history.goBack();
  }, []);

  // reset password api func
  async function handleResetPassword() {
    let obj = {
      password: password,
      email:
        location.state &&
        location.state.emailResponse &&
        location.state.emailResponse.email,
      org: location?.state?.emailResponse?.org,
    };
    dispatch({ type: "SET_LOADING", payload: true });
    let res = await resetPassword(obj);
    dispatch({ type: "SET_LOADING", payload: false });
    if (res && res.type == "success") {
      toast.success(
        res && res.message ? res.message : "Password reset done successfully.",
        { toastId: "reset-password-success" }
      );
      return history.push("/login");
    }
    toast.error(res && res.message ? res.message : "something went wrong", {
      toastId: "reset-password-error",
    });
    setStates({ disableButton: false });
  }

  const FormSchema = yup.object().shape({
    password: yup
      .string()
      .min(15, "15_character")
      .matches(/[0-9]/, "numeric")
      .matches(/[a-z]/, "lowercase")
      .matches(/[A-Z]/, "uppercase")
      .matches(/[^\w]/, "special"),
    confirmPassword: yup
      .string()
      .oneOf(
        [yup.ref("password"), null],
        "Must match New Password field value"
      ),
  });

  function getErrorsFromValidationError(validationError) {
    const FIRST_ERROR = 0;
    return validationError.inner.reduce((errors, error) => {
      return {
        ...errors,
        [error.path]: error.errors[FIRST_ERROR],
      };
    }, {});
  }

  function handleErrorMeg(values, FormSchema) {
    try {
      FormSchema.validateSync(values, { abortEarly: false });
      return {};
    } catch (error) {
      return getErrorsFromValidationError(error);
    }
  }

  useEffect(() => {
    if (password || confirmPassword) {
      if (password?.length > 0) {
        let passError = handleErrorMeg({ password }, FormSchema);
        setError(passError);
      }
      if (confirmPassword?.length > 0) {
        let conPassError = handleErrorMeg(
          { password, confirmPassword },
          FormSchema
        );
        setError(conPassError);
      }
    } else {
      setError({});
    }
  }, [password, confirmPassword]);

  return (
    <LoginParent>
      <div className={classes.resetPasswordText}>
        <ArrowBackOutlinedIcon
          style={{ cursor: "pointer" }}
          onClick={() => {
            history.push("/login");
          }}
        />
        <br />
        Reset Password
      </div>
      <Loader loading={state.loading}>
        <div className={classes.inputMainDiv}>
          <Grid className={classes.inputRow}>
            <Grid xs={12} sm={12} lg={12}>
              <CssTextField
                id="password"
                label="Enter New Password"
                type={states.showPassword ? "text" : "password"}
                fullWidth={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          setStates({ showPassword: !states.showPassword });
                        }}
                        edge="end"
                      >
                        {states.showPassword ? (
                          <VisibilityOutlinedIcon
                            className={classes.inputIcon}
                          />
                        ) : (
                          <VisibilityOffOutlinedIcon
                            className={classes.inputIcon}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                  // ...params.inputProps,
                  // autoComplete: 'no',
                  

                }}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                onFocus={() => {
                  setPasswordNeed(true)
                }}
                onBlur={() => {
                  setPasswordNeed(false)
                }}
                // autoComplete="new-password"
                // onfocus="this.removeAttribute('readonly')"

                onPaste={(e) => {
                  e.preventDefault();
                  return false;
                }}
                // autoComplete={false}
              />
            </Grid>
          </Grid>
          {/* {error?.password && (
            <span className={classes.error}>{error?.password}</span>
          )} */}
        </div>
        <div className={passwordNeed ? (password?.length === 0 || error?.password?.length > 0) ? classes.errorInvalid : classes.errorValid : classes.error}>{(password?.length === 0 || error?.password?.length > 0) ? <LockIcon /> : <LockOpenIcon />}Your password needs to:</div>
        <div className={passwordNeed ? password.length >= 15 ? classes.errorValid : classes.errorInvalid : classes.error}>{password.length > 0 ? password.length >= 15 ? <DoneIcon /> : <CloseIcon /> : ''}Must be 15 Characters</div>
        <div className={passwordNeed ? String(password).match(/[a-z]/) ? classes.errorValid : classes.errorInvalid : classes.error}>{password.length > 0 ? String(password).match(/[a-z]/) ? <DoneIcon /> : <CloseIcon /> : ''} Must be atleast one Lowercase</div>
        <div className={passwordNeed ? String(password).match(/[A-Z]/) ? classes.errorValid : classes.errorInvalid : classes.error}>{password.length > 0 ? String(password).match(/[A-Z]/) ? <DoneIcon /> : <CloseIcon /> : ''}Must be atleast one Uppercase</div>
        <div className={passwordNeed ? String(password).match(/[0-9]/) ? classes.errorValid : classes.errorInvalid : classes.error}>{password.length > 0 ? String(password).match(/[0-9]/) ? <DoneIcon /> : <CloseIcon /> : ''}Must be atleast one Numeric character</div>
        <div className={passwordNeed ? String(password).match(/[^\w]/) ? classes.errorValid : classes.errorInvalid : classes.error}>{password.length > 0 ? String(password).match(/[^\w]/) ? <DoneIcon /> : <CloseIcon /> : ''} Must be atleast one Special character</div>
        <div className={classes.inputMainDiv}>
          <Grid className={classes.inputRow}>
            <Grid xs={12} sm={12} lg={12}>
              <CssTextField
                id="password"
                label="Confirm Password"
                type={states.showConfirmPassword ? "text" : "password"}
                fullWidth={true}
                autoComplete="off"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          setStates({
                            showConfirmPassword: !states.showConfirmPassword,
                          });
                        }}
                        edge="end"
                      >
                        {states.showConfirmPassword ? (
                          <VisibilityOutlinedIcon
                            className={classes.inputIcon}
                          />
                        ) : (
                          <VisibilityOffOutlinedIcon
                            className={classes.inputIcon}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),

                }}
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  return false;
                }}
                onFocus={() => {
                  setConfirmPasswordNeed(true)
                }}
                onBlur={() => {
                  setConfirmPasswordNeed(false)
                }}


                disabled={password?.length === 0 || error?.password?.length > 0}
              />
            </Grid>
          </Grid>
          {/* {error?.confirmPassword && (
            <span className={classes.error}>{error?.confirmPassword}</span>
          )} */}

        </div>
        <div className={confirmPasswordNeed ? (error?.confirmPassword || confirmPassword?.length == 0) ? classes.errorInvalid : classes.errorValid : classes.error}>{(error?.confirmPassword || confirmPassword?.length == 0) ? <CloseIcon /> : <DoneIcon />}Must match New Password field value</div>

        {/* <div className={password.length > 0 ? String(password).match(/[a-z]/) ? "hh" : "jj" : classes.error}>it must not match any of your previous 5 passwords</div> */}
      </Loader>
      <div className={classes.btnDiv}>
        <Button
          variant="contained"
          className={classes.btn}
          onClick={() => {
            if (error?.password || error?.confirmPassword) {
              return toast.error("Please provide a valid password.", {
                toastId: "password-error",
              });
            } else if (!password || !confirmPassword) {
              return toast.error("Password field cannot be empty.", {
                toastId: "password-error2",
              });
            } else if (password && confirmPassword) {
              handleResetPassword();
              setStates({ disableButton: true });
            }
          }}
        >
          Proceed
        </Button>
      </div>


    </LoginParent>
  );
}
